module.exports = __webpack_public_path__ + "img/EPBusinessBack1.d09e3dd6.png";